import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { SYSTEMS_SLUG_ORDER } from '../data/systemsCatalog';

const API = `${(process.env.CRA_API_BASE_URL || process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_BACKEND_URL)}/api`;

const SystemsCatalogContext = createContext({
  services: null,        // { slug: service }
  orderedSlugs: [],
  getService: () => null,
  getTier: () => null,
  loading: true,
  error: null,
});

export function SystemsCatalogProvider({ children }) {
  const [services, setServices] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get(`${API}/systems/services`);
        if (!cancelled) setServices(res.data.services);
      } catch (e) {
        if (!cancelled) setError(e.message || 'Failed to load catalog');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const orderedSlugs = services
    ? SYSTEMS_SLUG_ORDER.filter((s) => services[s]).concat(
        Object.keys(services).filter((s) => !SYSTEMS_SLUG_ORDER.includes(s))
      )
    : [];

  const getService = (slug) => (services ? services[slug] : null);
  const getTier = (slug, tierId) => {
    const svc = getService(slug);
    if (!svc) return null;
    return svc.tiers.find((t) => t.id === tierId) || null;
  };

  return (
    <SystemsCatalogContext.Provider
      value={{ services, orderedSlugs, getService, getTier, loading, error }}
    >
      {children}
    </SystemsCatalogContext.Provider>
  );
}

export function useSystemsCatalog() {
  return useContext(SystemsCatalogContext);
}
